import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../lib/store";


export type EquipoCustom = {
    primerIntegrante: IntegranteDisponible;
    segundoIntegrante: IntegranteDisponible;
}

export type IntegranteDisponible = {
    id: number;
    nombre: string;
    disponible: boolean;
    tipo: string | null;
    equipoIndex: number;
}

export type EquipoDisponible = {
    identificador: string;
    primerIntegrante: IntegranteDisponible;
    segundoIntegrante?: IntegranteDisponible;
}

export type ActiveForm = "Nocturno" | "Personalizado" | "Ninguno"; 

export type EquiposVentaState = {
    nuevoEquipoCustom: EquipoCustom | null;
    equiposDisponibles: EquipoDisponible[];
    currentActiveForm: ActiveForm;
}

const initialState: EquiposVentaState = { nuevoEquipoCustom: null, equiposDisponibles: [], currentActiveForm: "Ninguno" };

export const equiposVentaSlice = createSlice({
    name: "equiposVenta",
    initialState,
    reducers: {
        setNuevoIntegrante: (state, action: PayloadAction<{ integrante: IntegranteDisponible, spot: "Primero" | "Segundo" }>) => {
            const nuevoIntegrante = action.payload;
            const currentTeam = state.nuevoEquipoCustom ?? { } as EquipoCustom;

            // set el nuevo integrante y reset el estado del antiguo integrante
            if(nuevoIntegrante.spot == "Primero") {
                if(state.nuevoEquipoCustom && state.nuevoEquipoCustom.primerIntegrante) {
                    // TODO: refactorizar este pedo
                    const oldIntegrante = currentTeam.primerIntegrante;
                    const team = state.equiposDisponibles[oldIntegrante.equipoIndex];
                    // reset integrantes state 
                    team.primerIntegrante.disponible = true;
                    if(team.segundoIntegrante)
                        team.segundoIntegrante.disponible = true;

                    state.equiposDisponibles[oldIntegrante.equipoIndex] = team;
                }
                currentTeam.primerIntegrante = nuevoIntegrante.integrante;
            } else {
                if(state.nuevoEquipoCustom && state.nuevoEquipoCustom.segundoIntegrante) {
                    // TODO: refactorizar este pedo
                    const oldIntegrante = currentTeam.segundoIntegrante;
                    const team = state.equiposDisponibles[oldIntegrante.equipoIndex];
                    // reset integrantes state 
                    team.primerIntegrante.disponible = true;
                    if(team.segundoIntegrante)
                        team.segundoIntegrante.disponible = true;

                    state.equiposDisponibles[oldIntegrante.equipoIndex] = team;
                }

                currentTeam.segundoIntegrante = nuevoIntegrante.integrante;
            }

            state.nuevoEquipoCustom = currentTeam;
        },
        resetEquipoCustom: (state) => {

            if(state.nuevoEquipoCustom) {
                // TODO: Refactorizar en una funcion utilitaria.
                const oldTeam = state.nuevoEquipoCustom;

                if(oldTeam.primerIntegrante) {
                    const primerIntegranteTeam = state.equiposDisponibles[oldTeam.primerIntegrante.equipoIndex];
                    primerIntegranteTeam.primerIntegrante = {...primerIntegranteTeam.primerIntegrante, disponible: true};

                    if(primerIntegranteTeam.segundoIntegrante)
                        primerIntegranteTeam.segundoIntegrante = {...primerIntegranteTeam.segundoIntegrante, disponible: true};
                }

                if(oldTeam.segundoIntegrante) {
                    const segundoIntegranteTeam = state.equiposDisponibles[oldTeam.segundoIntegrante.equipoIndex];
                    segundoIntegranteTeam.primerIntegrante = {...segundoIntegranteTeam.primerIntegrante, disponible: true};

                    if(segundoIntegranteTeam.segundoIntegrante)
                        segundoIntegranteTeam.segundoIntegrante = {...segundoIntegranteTeam.segundoIntegrante, disponible: true};
                }
            }

            state.nuevoEquipoCustom = null;
        },
        setEquposDisponibles: (state, action: PayloadAction<EquipoDisponible[]>) => {
            state.equiposDisponibles = action.payload;
        },
        changeIntegranteState: (state, action: PayloadAction<{ indexTeam: number, state: boolean, integranteId: number }>) => {
            const equipoDisponible = state.equiposDisponibles;
            const payload = action.payload;

            const team = equipoDisponible[payload.indexTeam];

            if(payload.integranteId == team.primerIntegrante.id)
                team.primerIntegrante = {...team.primerIntegrante, disponible: payload.state };
            else
                if(team.segundoIntegrante)
                    team.segundoIntegrante = {...team.segundoIntegrante, disponible: payload.state };

            equipoDisponible[payload.indexTeam] = team;
            state.equiposDisponibles = equipoDisponible;
        },
        changeActiveForm: (state, action: PayloadAction<ActiveForm>) => {
            state.currentActiveForm = action.payload;
        }
    }
});

export default equiposVentaSlice.reducer;
export const selectCurrentCustomTeam = (state: RootState) => state.equiposVenta.nuevoEquipoCustom; 
export const selectEquiposDisponibles = (state: RootState) => state.equiposVenta.equiposDisponibles;
export const selectCurrentActiveForm = (state: RootState) => state.equiposVenta.currentActiveForm;
export const { 
    setNuevoIntegrante,
    resetEquipoCustom,
    setEquposDisponibles,
    changeIntegranteState,
    changeActiveForm,
} = equiposVentaSlice.actions;